export default "__VITE_ASSET__Di0R5Hgt__"